import { AdditionalServices } from "widgets/additionalServices";

export const BreedingPortalPage = () => <AdditionalServices serviceName='Селекционный портал'/>
